import {DateHelper, Model} from "@bryntum/schedulerpro";
import {getAging} from "../../other/utils/utils.jsx";

export class Board extends Model {
  static get $name() {
    return "Board";
  }

  static get fields() {
    return [
      { name: "name", dataSource: "display_name" },
      { name: "owner", dataSource: "owner"},
      { name: "boardIdToCopy", dataSource: "source_board_id"},
      { name: "boardDataCopyOptions", dataSource: "selected_options" },
      { name: "slug", dataSource: "slug", persist: false },
      { name: "adminEmails", dataSource: "admin_emails", type: "array", persist: false },
      // for now, we're dealing roles a single integer value
      { name: "roles", dataSource: "roles", persist: false },
      { name: "grants", dataSource: "grants", type: "array", persist: false },
      { name: "isSandbox", dataSource: "is_sandbox", type: "boolean", persist: false },
      { name: "isHasFaqEditAccess", dataSource: "has_faq_edit_access", type: "boolean", persist: false },
      // meta properties
      { name: "creator", dataSource: "creator", persist: false },
      { name: "createdAt", dataSource: "created_at", persist: false },
      { name: "updater", dataSource: "updater", persist: false },
      { name: "updatedAt", dataSource: "updated_at", persist: false },
      { name: "creatorId", dataSource: "creator_id"},
      // non persisted fields
      { name: "deleteDate", dataSource: 'delete_date', type: "date", persist: false },
      { name: "deletedBy", dataSource: 'deleted_by', type: "date", persist: false },
      { name: "timezone", dataSource: 'timezone', readOnly: true },
      { name: "isOwner", dataSource: "is_owner"},
      { name: "isWorkforceActive", dataSource: "is_workforce_active", type: "boolean"}
    ];
  }

  set name(value) {
    // if an empty board name provided then don't update board name
    if (value?.trim()) {
      this.set("name", value);
    }
  }

  get name() {
    return this.get("name");
  }

  get roleNames() {
    const allRoles = this.firstStore.appRoles;
    return this.roles ? allRoles.filter((role) => this.roles === role.id).map((role) => role.name): [];
  }

  get lastUpdatedAt() {
    return DateHelper.formatCount(getAging(this.updatedAt), 'day')
  }

  get age() {
    return DateHelper.formatCount(getAging(this.createdAt), 'day');
  }
}

Board.exposeProperties();
